import BaseAPI from "./base/base-api";
import commonFn from "@/commons/commonFunction";
import httpClient from "@/apis/base/axios-httpclient";

class OrganizationUnitAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "OrganizationUnit";
  /**
   * nnphong - lấy cơ cấu tổ chức phân quyền
   */
  withOrganiztionUnitPermission(userID) {
    let request = {
      url: [this.getAPIUrl() + "/with_permission", userID].join("/"),
    };
    return httpClient.getAsync(request);
  }
  /*
   * Lấy dữ liệu bảng cơ cấu tổ chức được tích chọn là đơn vị quản lý
   * pvduy 13/04/2021
   */
  getListOrganizationUnitManagerment(payload) {
    let param = { ...payload };
    //xử lý tham số trước khi request load dữ liệu
    commonFn.processComboboxParamRequest(param);

    let request = {
      url: this.getAPIUrl() + "/list-organization-unit-is-managerment",
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new OrganizationUnitAPI();
